import { render, staticRenderFns } from "./SearchProductTag.vue?vue&type=template&id=a3105628&scoped=true"
import script from "./SearchProductTag.vue?vue&type=script&lang=js"
export * from "./SearchProductTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3105628",
  null
  
)

export default component.exports